import { scrollLayoutContentTo } from './scrollLayoutContentTo';

export function scrollLayoutContentToTop() {
  scrollLayoutContentTo(0, 0);
}
